import React from "react";
import styled, { css } from "styled-components";

const Image = styled.img`
    // height: 128px;
    //width: 249px;
`;

export default Image;